import { TableFootVariantType } from './variants';
export const getTableFootStyles = (FOUNDATIONS, FONT) => {
    return {
        [TableFootVariantType.DEFAULT]: {
            container: {
                display: 'table-footer-group',
            },
        },
    };
};
//# sourceMappingURL=styles.js.map